<template>
   <div class="card mb-0" ref="servico" :class="dadosUsuario.usuarioEntidade || servico.feedback ? 'cursor-pointer pt-1 pb-2' : ''" @click="feedback">
      <div class="body text-center pb-2 pt-2">
         <h6 class="limitador mb-2" v-if="servico.nomeApenado != null">{{ servico.nomeApenado == null ? 'Desconhecido' : servico.nomeApenado }}</h6>
         <h6 class="limitador mb-2" v-else-if="servico.nomeEntidade != null">{{ servico.nomeEntidade == null ? 'Desconhecido' : servico.nomeEntidade }}</h6>
         <h6 class="limitador mb-2" v-else>{{ servico.descricao == null ? 'Desconhecido' : servico.descricao }}</h6>
         
         <div class="text-start">
            <span class="limitador d-block mb-1" v-if="servico.nomeApenado != null && servico.nomeEntidade != null">
               <span><span class="color-theme mr-2">Entidade:</span>{{ servico.nomeEntidade }}</span>
            </span>
            <span class="limitador d-block mb-1" v-if="servico.feedback != null">
               <span class="color-theme mr-2">Nota:</span>
               <i class="fas fa-star font-13 mr-2" :class="servico.feedback >= 1 ? 'text-warning' : 'text-secondary'"></i>
               <i class="fas fa-star font-13 mr-2" :class="servico.feedback >= 2 ? 'text-warning' : 'text-secondary'"></i>
               <i class="fas fa-star font-13 mr-2" :class="servico.feedback >= 3 ? 'text-warning' : 'text-secondary'"></i>
               <i class="fas fa-star font-13 mr-2" :class="servico.feedback >= 4 ? 'text-warning' : 'text-secondary'"></i>
               <i class="fas fa-star font-13 mr-2" :class="servico.feedback == 5 ? 'text-warning' : 'text-secondary'"></i>
               <small>({{ servico.feedback }})</small>
            </span>
            <span class="limitador d-block mb-1"><span class="color-theme">Horas cumpridas: </span>{{ servico.horas == null ? 0 : servico.horas }}h</span>
            <span class="limitador-2 d-block mb-1"><span class="color-theme">Descrição: </span>{{ servico.descricao == null ? 0 : servico.descricao }}</span>
         </div>
         
         <button type="button" class="btn btn-default btn-sm mt-2 mb-2 mr-1" @click="editar" v-if="!dadosUsuario.usuarioEntidade && !view && !servico.feedback">
            <span><i class="far fa-pencil font-13"></i><span> Editar</span></span>
         </button>
         <button type="button" class="btn btn-default btn-sm mt-2 mb-2" @click="excluir(servico.id)" v-if="!dadosUsuario.usuarioEntidade && !view && !servico.feedback">
            <span><i class="far fa-trash font-13"></i><span> Deletar</span></span>
         </button>
         
         <span class="limitador d-block font-12 text-secondary">{{ servico.data == null ? 'Desconhecido' : new Date(servico.data.year +'/'+ servico.data.monthValue +'/'+ servico.data.dayOfMonth).toLocaleDateString() }}</span>
      </div>
   </div>
</template>

<script>

import Swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {
	name: 'Sentencas',
   props: ['servico', 'index', 'view'],
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   methods: {
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
      feedback : function () {
         if (this.dadosUsuario.usuarioEntidade || this.servico.feedback) {
            this.$emit('feedback', this.servico)
         }
      },
      editar : function () {
         this.$emit('editar', this.servico)
      },
      excluir : function (id) {
         let ref = this;

         Swal.fire({
            icon: 'warning',
            title: 'Excluir serviço',
            confirmButtonText: 'Confirmar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'

         }).then((result) => {
            if (result.isConfirmed) {
               ref.$store.dispatch('alternarTelaCarregamento', true)
               
               ref.$axios({
                  method: 'post',
                  url: ref.urlRest +'servicos/deleteServico',
                  params:{
                     id: id
                  }
               }).then(function () {
                  ref.$refs.servico.style.display = 'none'

                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Serviço excluído!'
                  })
               }).catch(function (error) {
                  if (error.response != undefined) {
                     if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                           icon: 'warning',
                           title: 'Sessão expirada!'
                        });
                     } else {
                        ref.$toast.fire({
                           icon: 'error',
                           title: 'Erro: ' + error.response.status
                        })
                     }
                  } else {
                     ref.$toast.fire({
                        icon: 'error',
                        title: error
                     })
                  }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false)
               })
            }
         });
      }
   }
}

</script>

<style scoped>
.text-start {
   text-align: start !important;
}
</style>
